import React from "react";
import Layout from "@/components/Layout";
import usePageMeta from "@/hooks/use-page-meta";
import Hero from "@/components/sections/Hero";
import TrustSection from "@/components/sections/TrustSection";
import ServicesSection from "@/components/sections/ServicesSection";
import { WhyChoose, ProcessSection } from "@/components/sections/WhyAndProcess";
import MedicalEquipmentPreview from "@/components/sections/MedicalEquipmentPreview";
import AreasWeServe from "@/components/sections/AreasWeServe";
import Testimonials from "@/components/sections/Testimonials";
import GoogleReviews from "@/components/sections/GoogleReviews";
import EmergencyBanner from "@/components/sections/EmergencyBanner";
import LatestBlogsPreview from "@/components/sections/LatestBlogsPreview";
import FAQ from "@/components/sections/FAQ";
import ContactSection from "@/components/sections/ContactSection";

export default function LandingPage() {
  usePageMeta(
    "KinFlex Home Healthcare — 24×7 Home Nursing & Critical Care in Delhi NCR",
    "Premium home healthcare in Delhi NCR — verified nurses, ICU setup, physiotherapy, elder care, medical procedures & equipment rental. 24×7 emergency support."
  );
  return (
    <Layout transparentOnHero>
      <Hero />
      <TrustSection />
      <ServicesSection />
      <WhyChoose />
      <ProcessSection />
      <MedicalEquipmentPreview />
      <AreasWeServe />
      <Testimonials />
      <GoogleReviews />
      <EmergencyBanner />
      <LatestBlogsPreview />
      <FAQ />
      <ContactSection subheading="Let's bring expert care to your home." />
    </Layout>
  );
}
